module.exports = __webpack_public_path__ + "img/logo_catalyst.a776ca48.png";